export default __webpack_public_path__ + "static/media/about-1.680625eb.png";